<template>
  <header class="subHeader">
    <div class="content-header">DELETED</div>
    <div class="content-body">Deleted events</div>
  </header>
</template>
<script>
  export default {
    name: 'subHeaderDeleted',
    methods: {
      sidebarToggle (e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
      }
    }
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// SubHeaderDeleted.vue?46936925